/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_CFG_PERIODS_ITEM = {
  id: 'periods',
  screenId: 'acc-cfg-periods',
  label: 'Períodos contables',
  description: 'Ejercicio en curso y estado de cada mes.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís el ejercicio fiscal con el que trabajás y abrís o cerrás cada mes. Solo en períodos «Abierto» se pueden generar o cargar asientos.',
      },
      {
        title: 'Paso 1 — Ejercicio en curso',
        fields: [
          { label: 'Ejercicio en curso', description: 'Año fiscal seleccionado. Al cambiarlo se guarda automáticamente.' },
        ],
        paragraphs: [
          'Si el ejercicio no tiene meses cargados, tocá «Crear ejercicio» para generar los 12 períodos mensuales (+ cierre).',
        ],
      },
      {
        title: 'Paso 2 — Estados de cada mes',
        bullets: [
          'Abierto — permite asientos. Cerrar → pasa a Cerrado.',
          'Cerrado — no admite nuevos asientos. Bloquear → Bloqueado (definitivo para auditoría).',
          'Abierto de nuevo con el botón «Abrir» si hace falta corregir.',
        ],
      },
      {
        title: 'Otros ejercicios',
        paragraphs: ['Desplegá «Otros ejercicios» para ver años anteriores en solo lectura de estado.'],
      },
    ],
  },
}
